import { connect } from 'react-redux';
import { getOptionalQuestions, getRequiredQuestions } from '../reducer';
import Questions from './Questions';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var order = _ref.order,
    serviceDetails = _ref.serviceDetails;
  var serviceIdentities = _ref2.serviceIdentities,
    methods = _ref2.methods;
  return {
    methods: methods,
    optionalQuestions: getOptionalQuestions({
      order: order,
      serviceDetails: serviceDetails
    }),
    questions: serviceDetails.questions,
    questionsRequiringPreviousSelection: serviceDetails.questionsRequiringPreviousSelection,
    requiredQuestions: getRequiredQuestions({
      order: order,
      serviceDetails: serviceDetails
    }),
    serviceIdentities: serviceIdentities,
    status: serviceDetails.status
  };
};
export default connect(mapStateToProps)(Questions);